import dataScheme from "./video_data_to_render.json";
import { Composition, CalculateMetadataFunction } from "remotion";
import { DesignSystem } from "./Components/DesignSystem";
import TrebbleClipCreatorInput, { TrebbleClipCreatorInputConfig ,TemplateInputConfig, VideoInputConfig } from "./TrebbleClipCreator";
import { FrameDemoProps } from "./FramedDemo";
import { trebbleClipCreatorInputSchema, TrebbleClipCreatorInputSchema } from "./TrebbleClipCreatorSchema";

// Extend Window interface if not already done globally
declare global {
    interface Window {
      getI18n: (i18nData: any, key: string, options?: any) => string;
    }
  }

// Each <Composition> is an entry in the sidebar!

// List of video configurations for different social media platforms
// Portrait Video for Social Media (TikTok, Instagram Reels, YouTube Shorts)
const videoSettings: FrameDemoProps = {
  frameURL: "",
  canvas: {
    aspectRatio: "9:16",
    width: 1080,
    height: 1920,
    safeZone: {
      top: 100,
      bottom: 100,
      left: 100,
      right: 100,
    },
  },
};



// Default video config for the demo
const designSystemConfig: DesignSystem = {
  style: "classic",
  primaryColor: "#0521A1",
  secondaryColor: "#42f554",
  accentColor: "#f5425d",
  titleFont: "Times New Roman",
  bodyFont: "Times New Roman",
  logoURL: "https://images.squarespace-cdn.com/content/v1/54c81a6fe4b0652cb365f97d/1535192418838-95VVAQV7U1R2P4DR2HVC/rsz_1rsz_1trebblelogofullred.png?format=1500w",
  canvas: videoSettings.canvas,
  titleFontOutline: "none",
  bodyFontOutline: "none",
  borderRadius: 0
}

const AnimationTimings = {
  speaker: {
    fromTime: 0,
    // toTime: 1300,
    delay: 0,
  },
  watermark: {
    fromTime: 0,
    // toTime: 5000,
    delay: 15,
  },
};

export const templateInputConfigDemo : TemplateInputConfig ={
  "showCaption": true,
  "overrideThemeCaption": false,

  "videoConfig": {
    "borderRadius": 0,
    "padding": false,
    "border": false,
    "scale": 1,
    "framing": {
      "name": "default",
      "1:1": {
        "focusRegions": []
      },
      "9:16": {
        "focusRegions": []
      },
      "16:9": {
        "focusRegions": []
      }
    },
    "borderStyle": "no_border"
  },
  "speakerDesignConfig": {
    "animation": {
      "fromTime": 0,
      "delay": 0
    },
    "firstName": "John",
    "lastName": "Doe",
    "title": "Founder",
    "company": "Trebble",
    "position": "bottom left",
    "showSpeakerLabels": false
  },
  "designSystem": {
    "style": "classic",
    "primaryColor": "#0521A1",
    "secondaryColor": "#42f554",
    "accentColor": "#f5425d",
    "titleFont": "Times New Roman",
    "bodyFont": "Times New Roman",
    "logoURL": "https://images.squarespace-cdn.com/content/v1/54c81a6fe4b0652cb365f97d/1535192418838-95VVAQV7U1R2P4DR2HVC/rsz_1rsz_1trebblelogofullred.png?format=1500w",
    "canvas": {
      "aspectRatio": "9:16",
      "width": 1080,
      "height": 1920,
      "safeZone": {
        "top": 100,
        "bottom": 100,
        "left": 100,
        "right": 100
      }
    },
    "titleFontOutline": "none",
    "bodyFontOutline": "none",
    "borderRadius": 0
  },
  "savedThemeConfig": {
    "themeConfig": {
      "brandConfig": {
        "primaryColor": "#e97d53",
        "secondaryColor": "#ffe62c",
        "accentColor": "#f0f0f0",
        "titleFont": "alfaSlabOne",
        "bodyFont": "bangers",
        "logoURL": "",
        "titleFontOutline": "none",
        "bodyFontOutline": "none",
        "borderRadius": 0
      },
      "backgroundConfig": {
        "format": "color",
        "color": "#ef8c8c",
        "imageURL": ""
      },
      "frameConfig": {
        "padding": false,
        "borderRadius": 0,
        "border": false,
        "borderStyle": "no_border"
      },
      "savedCaptionConfig": {
        "name": "Trebble caption 1",
        "type": "trebble",
        "captionConfig": {
          "milisecondGrouping": 1000,
          "font": "silkscreen",
          "useDesignSystemColor": true,
          "mainColor": "#780C28",
          "highlightColor": "#CAE0BC",
          "fontSizeRatio": "medium",
          "outline": "3d-stroke",
          "background": "white",
          "textAnimation": "highlight",
          "borderRadius": 0,
          "captionCase": "standard",
          "hidePunctuation": false,
          "position": "bottom center",
          "maxLines": "two_lines",
          "showOneWordOnly": false
        },
        "id": "680f93aba948e7f8544d79b1"
      }
    },
    "name": "Trebble theme 1",
    "type": "trebble",
    "id": "680f8c584d89d3eee18e68d2"
  },
  "watermarkDesignConfig": {
    "animation": {
      "fromTime": 0,
      "delay": 0
    },
    "imageURL": "https://beta-web.trebble.fm/css/images/trebbleLogoFullRed300x69.png",
    "opacity": 100,
    "scale": 0.15,
    "position": "top right",
    "showWatermark": false
  },
  "backgroundDesignConfig": {
    "imageURL": "https://images6.alphacoders.com/376/thumb-1920-376931.jpg",
    "color": "#000000",
    "format": "color"
  },
  "savedCaptionConfig": undefined
}
export const videoInputConfigDemo : VideoInputConfig = {
  videoRenderData: dataScheme,
  audioUrl: "",
  durationInMs: 5000,
  framePerSec: 30,
  startTimeOffset: 0,
  firstScheduledNode: null,
  inCloudRenderingEnvironment: true,
}

export const trebbleClipCreatorInputDemo: TrebbleClipCreatorInputConfig = {
  templateInputConfig: {...templateInputConfigDemo},
  videoInputConfig: {...videoInputConfigDemo}
}

export const RemotionRoot: React.FC = () => {
  const calculateMetadata: CalculateMetadataFunction<TrebbleClipCreatorInputSchema> = ({props, defaultProps, abortSignal}) => {
    // Validate props against schema
    const validationResult = trebbleClipCreatorInputSchema.safeParse(props);
    if (!validationResult.success) {
      console.error('Invalid props:', validationResult.error);
      throw new Error( "INVALID_PROPS_CONFIGURATION");
    }

    return {
      durationInFrames: Math.floor(props.videoInputConfig.durationInMs * props.videoInputConfig.framePerSec / 1000),
      fps: props.videoInputConfig.framePerSec,
      width: props.templateInputConfig.designSystem.canvas.width,
      height: props.templateInputConfig.designSystem.canvas.height,
      props,
      defaultCodec: 'h264',
    };
  };

  // Validate default props
  const validationResult = trebbleClipCreatorInputSchema.safeParse(trebbleClipCreatorInputDemo);
  if (!validationResult.success) {
    console.error('Invalid default props:', validationResult.error);
    throw new Error('Invalid default props configuration');
  }

  return (
    <>
      <Composition
        id="TrebbleClipCreatorComposition"
        component={TrebbleClipCreatorInput}
        durationInFrames={10}
        fps={30}
        schema={trebbleClipCreatorInputSchema}
        width={trebbleClipCreatorInputDemo.templateInputConfig.designSystem.canvas.width}
        height={trebbleClipCreatorInputDemo.templateInputConfig.designSystem.canvas.height}
        defaultProps={trebbleClipCreatorInputDemo as TrebbleClipCreatorInputSchema}
        calculateMetadata={calculateMetadata}
      />
    </>
  );
};